import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class EnrollmentService {
    /**
    * Enrolls a new policy or account for the current user
    *
    * @param {Object} data enrollment data
    * @param {Object} additionalHeaders additional headers to pass to the backend (e.g. auth)
    * @returns {Promise} the promise from the backend call
    */
    static addEnrollmentRecord(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'addEnrollmentRecord', [data], additionalHeaders);
    }

    /**
    * Creates UW activity to enroll a new policy the current user
    *
    * @param {Object} data enrollment data
    * @param {Object} additionalHeaders additional headers to pass to the backend (e.g. auth)
    * @returns {Promise} the promise from the backend call
    */
     static requestPolicyEnrollment(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'requestEnrollment', [data], additionalHeaders);
    }

    static requestPolicyEnrollmentEmail(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'sendEmailForAddingPolicy', [data], additionalHeaders);
    }
    
    /**
    * Gets a list of policies available to the current user
    *
    * @param {Object} data enrollment data
    * @param {Object} additionalHeaders additional headers to pass to the backend (e.g. auth)
    * @returns {Promise} the promise from the backend call
    */
     static getAvailablePoliciesForEnrollment_EY(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyEnrollment'), 'getAvailablePoliciesForEnrollment_EY', [data], additionalHeaders);
    }
}
